import React from 'react';
import PropTypes from 'prop-types';
import { postAPI } from 'store/apiReducer';
import { connect } from 'react-redux';
import {
    Button,
    ButtonGroup,
    Col,
    Container,
    Label,
    LoaderMi,
    Row,
    Select,
    SelectGroup,
} from '@design-system-etat/dsfr-react';
import { FormProvider, useForm } from 'react-hook-form';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_CONTACTER_PREFECTURE_PUBLIC,
    CONTEXT_CONTACTER_PREFECTURE,
} from 'constants/apiUrls.constants';
import { DATA_THEME_NON_CONNECTE } from 'constants/contacter.constants';
import formaterContacter from './components/FormaterContacter';
import InformationsUtilisateurNonConnecte from './components/InformationsUtilisateurNonConnecte';
import FormulaireContactGenerique from '../../components/form/formulaireContactGenerique/FormulaireContactGenerique';
import { formaterOptions } from '../../utils/utils';
import InfoChampsObligatoire from '../../components/form/infoObligatoire/InfoChampsObligatoire';

const ContacterPrefectureNonConnecte = ({ isLoading, postApi }) => {
    const hookForm = useForm({
        mode: 'onChange',
    });
    const { register, handleSubmit, formState } = hookForm;

    const redirectionPageDeConnexion = () => {
        window.location.href = process.env.REACT_APP_HOST;
    };

    const onSubmit = async (dataForm) => {
        if (dataForm && formState.isValid) {
            const dataFormat = await formaterContacter(dataForm, false);

            postApi(
                usagerClientReducer,
                API_CONTACTER_PREFECTURE_PUBLIC,
                dataFormat,
                CONTEXT_CONTACTER_PREFECTURE,
            );
            setTimeout(() => {
                redirectionPageDeConnexion();
            }, 3000);
        }
    };

    return (
        <Container fluid={false}>
            {isLoading && <LoaderMi taille="md" />}
            <Row>
                <Col>
                    <h1>Nous contacter</h1>
                </Col>
            </Row>
            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <InfoChampsObligatoire />
                    <InformationsUtilisateurNonConnecte hookForm={hookForm} />
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <SelectGroup>
                                <Label htmlFor="theme">Thème *</Label>
                                <Select
                                    id="theme"
                                    name="theme"
                                    options={formaterOptions(DATA_THEME_NON_CONNECTE)}
                                    placeholder="-- Choisir une option --"
                                    {...register('theme', {
                                        required: 'Ce champ est obligatoire',
                                    })}
                                    required
                                />
                            </SelectGroup>
                        </Col>
                    </Row>
                    <FormulaireContactGenerique />
                    <ButtonGroup align="right" inline>
                        <Button
                            name="Annuler"
                            variant="secondary"
                            onClick={redirectionPageDeConnexion}
                        >
                            Annuler
                        </Button>
                        <Button
                            name="envoyer"
                            variant="primary"
                            type="submit"
                            disabled={!formState.isValid || isLoading}
                        >
                            Envoyer
                        </Button>
                    </ButtonGroup>
                </form>
            </FormProvider>
        </Container>
    );
};

ContacterPrefectureNonConnecte.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    postApi: PropTypes.func.isRequired,
    dataContacterPrefecture: PropTypes.shape({
        mailEnvoye: PropTypes.bool.isRequired,
    }).isRequired,
};

export default connect(
    (state) => {
        const { isLoading } = state.contact.nousContacter;
        return {
            isLoading,
        };
    },
    {
        postApi: postAPI,
    },
)(ContacterPrefectureNonConnecte);
